/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import AdmissionConsultant from './admission-consultant';
import AdmissionConsultantDetail from './admission-consultant-detail';
import AdmissionConsultantUpdate from './admission-consultant-update';
import AdmissionConsultantDeleteDialog from './admission-consultant-delete-dialog';

const AdmissionConsultantRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<AdmissionConsultant />} />
    <Route path="new" element={<AdmissionConsultantUpdate />} />
    <Route path=":id">
      <Route index element={<AdmissionConsultantDetail />} />
      <Route path="edit" element={<AdmissionConsultantUpdate />} />
      <Route path="delete" element={<AdmissionConsultantDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AdmissionConsultantRoutes;
